import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import constants from '../../constant.js';
import { Label } from "flowbite-react";
import PlusIcon from '@mui/icons-material/Add';

const ShuttleFare = () => {

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [status, setStatus] = useState(1);
    const [name, setName] = useState('');
    const [thresholds, setThresholds] = useState([{ minDist:'', maxDist: '', charge: ''}]);
    const [cancellationData, setCancellationData] = useState([]);
    const [policyId, setPolicyId] = useState(0);
    const [isShuttlePass, setIsShuttlePass] = useState(0);

    const navigate = useNavigate();
    const fetchCancellationData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_cancellation_policy';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setCancellationData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchCancellationData();
    }, [cityFilter]);

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setPolicyId(0);
        setStatus(1);
        setIsShuttlePass(0);
        setName('');
        setThresholds([{ minDist:'', maxDist: '', charge: ''}]);
    }

    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        
    }

    const handleOpenEdit = (row) => {
        setOpenEditModal(true);
        setPolicyId(row.policy_id);
        setStatus(row.is_active);
        setName(row.name);
        setIsShuttlePass(row.is_shuttle_pass);
    
        if (row.thresholds && Array.isArray(row.thresholds)) {
            // Convert ["4:8", "10:5"] to [{ minDist: X, maxDist: Y, charge: Z }]
            const thresholdArray = row.thresholds.map(threshold => {
                const [maxDist, charge] = threshold.split(':').map(Number);
                return {
                    minDist: '', // You can calculate minDist based on previous maxDist
                    maxDist,
                    charge,
                };
            });
    
            // Ensure minDist is set correctly based on previous maxDist
            thresholdArray.forEach((threshold, index) => {
                threshold.minDist = index === 0 ? 0 : thresholdArray[index - 1].maxDist + 1;
            });
    
            setThresholds(thresholdArray);
        }
        else if (row.thresholds && typeof row.thresholds === 'object') {
            const thresholdArray = Object.entries(row.thresholds).map(([maxDist, charge]) => {
                return {
                    minDist: '', // You can calculate minDist based on previous maxDist
                    maxDist: Number(maxDist),
                    charge: Number(charge),
                };
            });
            thresholdArray.forEach((threshold, index) => {
                threshold.minDist = index === 0 ? 0 : thresholdArray[index - 1].maxDist + 1;
            });
        
            setThresholds(thresholdArray);
        } else {
            setThresholds([{ minDist: '', maxDist: '', charge: '' }]);
        }
    };    

    const handleSubmit = async() => {
        const token = localStorage.getItem('token');
        // const formattedThresholds = thresholds.map(threshold => `${threshold.maxDist}:${threshold.charge}`);
        
        const formattedThresholds = thresholds.reduce((acc, threshold) => {
            if (threshold.maxDist !== '' && threshold.charge !== '') {
                acc[threshold.maxDist] = threshold.charge;
            }
            return acc;
        }, {});
    
        const payload = {
            token: token,
            name: name,
            city_id: cityFilter,
            is_active: status,
            thresholds: formattedThresholds,
            is_shuttle_pass: isShuttlePass==1 ? 1 : 0
        };
        if(policyId!=0){
            payload.policy_id = policyId;
        }

        try {
            const url = operationsUrl + '/shuttle/add_update_cancellation_policy';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchCancellationData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleThresholdChange = (index, field, value) => {
        const updatedThresholds = thresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setThresholds(updatedThresholds);
    };

    const handleAddThreshold = () => {
        const lastMaxDist = thresholds.length > 0 ? Number(thresholds[thresholds.length - 1].maxDist) : 0;

        setThresholds([...thresholds, { minDist: lastMaxDist + 1, maxDist: '', charge: '' }]);
        // console.log('thresholds====', thresholds)
    };

    const handleRemoveThreshold = (index) => {
        const updatedThresholds = thresholds.filter((_, i) => i !== index);
        setThresholds(updatedThresholds);
    };

    const handleCloseSnackbar = () => {
        showSnackbar(false);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Cancellation</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Cancellation
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '8%' }}>Policy ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '12%' }}>Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '8%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '18%' }}>Applicable for Shuttle pass</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Thresholds</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {cancellationData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                        cancellationData.map((row) => {

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.policy_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ minWidth: '100px',bgcolor: row.is_active === 1 ? '#0DBA78' : '#E3E5E8', color:'#fff', borderRadius:'16px', width:'100px', textAlign:'center' , display:'inline-block', padding:'2px'}}>
                                            {row.is_active==1 ? 'Active' : 'Inactive'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '120px', color: row.is_shuttle_pass === 1 ? '#0DBA78' : '#D14545', fontWeight:'500'  }}>
                                            {row.is_shuttle_pass==1 ? 'Yes' : 'No'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                    {Object.keys(row.thresholds).length > 0 ? (
                                        Object.entries(row.thresholds).map(([maxTime, refundPercentage], index, entries) => {
                                            const minTime = index === 0 ? 0 : Number(entries[index - 1][0]) + 1; // Previous maxTime + 1

                                            return (
                                                <Typography key={index} sx={{ width: 'auto', minWidth: '100px', fontSize: '14px' }}>
                                                    Min Time (min): {minTime}<br />
                                                    Max Time (min): {maxTime}<br />
                                                    Refund (%): {refundPercentage}
                                                    <hr />
                                                </Typography>
                                            );
                                        })
                                    ) : (
                                        <Typography>No Thresholds</Typography>
                                    )}

                                    </TableCell>

                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEdit(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Cancellation' : 'Add Cancellation'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Name" fullWidth variant="outlined" type="text" 
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Status<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={status} 
                                            fullWidth
                                            onChange={(e) => setStatus( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            <MenuItem value="">Status</MenuItem>
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="0">Inactive</MenuItem>
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{mt:'3%'}}>
                                        <Box sx={{ 
                                            border: '1px solid #D1D1D1', 
                                            borderRadius: '8px',
                                            display: 'flex', bgcolor:'#f9f9f9',
                                            alignItems: 'center', pl:'1%',
                                            justifyContent: 'space-between',
                                            height: '50px' // Match the height of other form fields
                                        }}>
                                            <Label sx={{ margin: 0 }}>Shuttle Pass<span style={{ color: 'red' }}>*</span></Label>
                                            <Switch
                                                checked={isShuttlePass}
                                                onChange={(e) => setIsShuttlePass(e.target.checked ? 1 : 0)}
                                                inputProps={{ 'aria-label': 'Shuttle Pass Toggle' }}
                                                color="primary"
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{mt:'2%'}}>
                                        <Label>Thresholds<span style={{ color: 'red' }}>*</span></Label>
                                        
                                        <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Time (in min)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Time (in min)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Refund (%)</Typography>
                                                </Grid>
                                            </Grid>

                                            {thresholds.map((threshold, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.minDist}
                                                            // value={index === 0 ? Number(waitingChangesWindow)+1 : threshold.minDist}
                                                            onChange={(e) => handleThresholdChange(index, 'minDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.maxDist}
                                                            onChange={(e) => handleThresholdChange(index, 'maxDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.charge}
                                                            onChange={(e) => handleThresholdChange(index, 'charge', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {index === thresholds.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddThreshold}
                                                                startIcon={<PlusIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemoveThreshold(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Close
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </div>
                                    </Grid>

                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {openEditModal ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} message={message} />

        </div>
    )
}

export default ShuttleFare;